// extracted by mini-css-extract-plugin
export var icon = "_4q-1";
export var subtext = "_4q-0";